import axios from 'axios';

export const updateVerificationStatus = async (verification_id, userToken,) => {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}veriff/updateVerificationStatus`,
            { id: verification_id, token: userToken, status: "approved" } // Send id and status as the request body
        );
    
        // return response.data; // Return the response from the server
    } catch (error) {
        throw error.response.data; // Handle errors appropriately
    }
};